import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, COMMUNITY_FAQ_BODY_PATH } from '../../../../constant/Constant';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import { request } from '../../../ApiModule';
import { SET_GRID_DATA } from '../../../component/TableBoxModule';

const ACTION_SEARCH = COMMUNITY_FAQ_BODY_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = COMMUNITY_FAQ_BODY_PATH + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = COMMUNITY_FAQ_BODY_PATH + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = COMMUNITY_FAQ_BODY_PATH + PATH_DELIMITER + 'ACTION_REMOVE';
const ACTION_DETAIL = COMMUNITY_FAQ_BODY_PATH + PATH_DELIMITER + 'ACTION_DETAIL';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);
export const actionDetail = createAction(ACTION_DETAIL);

export function* communityFaqSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
    yield takeEvery(ACTION_DETAIL, actionDetailSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/board/faqs',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionAddSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/board/faqs',
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result.postingNo);
    }
}

function* actionEditSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/board/faqs/${params.postingNo}`,
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(params.postingNo);
    }
}

function* actionRemoveSaga({ payload: { params, callback } }) {
    let pno = parseInt(params.postingNo);

    const result = yield call(request, {
        method: 'delete',
        url: `/api/board/faqs/${params.postingNo}`,
        pno,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(pno);
    }
}

function* actionDetailSaga({ payload: { params, callback } }) {
    let pno = parseInt(params.postingNo);
    const result = yield call(request, {
        method: 'get',
        url: `/api/board/faqs/${params.postingNo}`,
        pno,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result);
    }
}
